<div class="privacy-checkbox--wrapper" [formGroup]="formGroup">
  <nx-checkbox #privacyCheckbox (checkboxChange)="onChange($event)" [formControlName]="field.name">
    {{ field.label | translate }}
  </nx-checkbox>
</div>
<div class="download--wrapper" *ngIf="field.linkName">
  <nx-link>
    <a
      class="nx-margin-left-2m nx-margin-top-3xs"
      [href]="field.path ?? '' | translate"
      [attr.download]="field.nameFile ? (field.nameFile | translate) : null"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ field.linkName | translate }}</a
    >
  </nx-link>
</div>
